export default {
  isTrustPayOrder() {
    let searchParams = new URLSearchParams(window.location.search);

    return searchParams.get('payment') === 'trustpay';
  },
};
